export default "__VITE_ASSET__CNikCWw3__"